import * as R from 'ramda';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { withRouter } from 'react-router';
import React, { PureComponent } from 'react';
import { SubmissionError } from 'redux-form';
import { withNamespaces } from 'react-i18next';
import commonUtil from 'utilsModule/common';
import { withResource, resourceTypes, gettersOf } from 'dataModule/store/resources';
import { actionCreators as messageActionCreators } from 'appModule/message/ducks/message';
import { ForgetPasswordVerify } from '../components';

@withNamespaces('auth', { wait: true })
@withResource([{ resourceType: resourceTypes.USERS }])
@connect(null, { notify: messageActionCreators.show })
@withRouter
class ForgetPasswordVerifyContainer extends PureComponent {
  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  sendOTP = () => {
    const { actionCreators, notify, t } = this.props;

    const mobileNumber = sessionStorage.getItem('verifyPhone');
    actionCreators[resourceTypes.USERS].ajax({
      cargo: { method: 'forgetPassword', input: { content: { phone: mobileNumber } } },
      onSuccess: () => {
        if (this.mounted) {
          notify({ message: t('forgetPassword.snackbarMessage.resendOtpSuccess'), type: 'success' });
        }
      },
      onFailure: ({ error, reject }) => {
        if (this.mounted) {
          const reportedError = JSON.stringify(error, ['code', 'message']);
          reject(new SubmissionError({ _error: reportedError }));
          notify({ message: `${error.message}`, type: 'error' });
        }
      },
    });
  };

  verifyOTP = ({ otp }) => {
    const {
      t, actionCreators, notify, history, location: { state: { changePassword = false } = {} } = {},
    } = this.props;
    
    const credentials = { code: R.pipe(R.values, R.join(''))(otp) };
    const mobileNumber = sessionStorage.getItem('verifyPhone');

    actionCreators[resourceTypes.USERS].ajax({
      cargo: { method: 'passwordVerifyOTP', input: { content: { phone: mobileNumber, otp: credentials.code } } },
      onSuccess: () => {
        if (changePassword) {
          history.push('/changepassword/setnewpassword', { changePassword: true });
        } else {
          history.push('/forgetpassword/setnewpassword');
        }
      },
      onFailure: ({ error }) => {
        notify({ message: t('forgetPassword.snackbarMessage.verifyOtpFailed'), type: 'error' });
      },
    });
  };

  convertToPhoneObject = (phone) => {
    if (!phone) return {};

    const phoneObject = phone.split(' ');
    return {
      countryCode: phoneObject[0],
      value: phoneObject[1],
    };
  }

  render() {
    const { t, data, location: { state: { changePassword = false } = {} } = {} } = this.props;

    // process.env.DEBUG && console.log('%crender ForgetPasswordVerifyContainer', 'font-size: 12px; color: #00b3b3', this.props);

    if (!this.inited) {
      this.initialValues = {};
      this.inited = true;
    }

    let sendViaMessage = '';
    const otpVia = gettersOf(resourceTypes.USERS).getForgotPassword2FAOtpVia()(data);
    if (otpVia && otpVia.method === 'SMS') {
      const mobileObj = this.convertToPhoneObject(otpVia.via);
      sendViaMessage = `${t('forgetPassword.subtitle2.001')} +${mobileObj.countryCode} ${mobileObj.value.toString().replace(/\d(?=\d{4})/g, '*').replace(mobileObj.value.slice(-4), '-' + mobileObj.value.slice(-4))}`;
    } else if (otpVia && otpVia.method === 'EMAIL') {
      sendViaMessage = `${t('forgetPassword.subtitle2.002')} ${commonUtil.maskEmail(otpVia.via)}`;
    }

    const timeoutMins = 5;
    this.runtimeProps = {
      header: {
        banner: {
          title: t('forgetPassword.title2'),
        },
      },
    };

    this.runtimeProps = update(this.runtimeProps, {
      header: {
        banner: {
          subtitle: {
            $set: t('forgetPassword.subtitle2.003', { sendViaMessage, timeoutMins })
          },
        },
      },
    });

    return <ForgetPasswordVerify
      initialValues={this.initialValues}
      runtimeProps={this.runtimeProps}
      verifyOTP={this.verifyOTP}
      sendOTP={this.sendOTP}
      changePassword={changePassword}
      t={t}
    />;
  }
}

export default ForgetPasswordVerifyContainer;
